module.exports = __webpack_public_path__ + "static/media/linkbanner_sm1.0570b44c.png";